import React, { useMemo } from "react"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"
import DynamicImage from "@/hooks/dynamicImage"
import Container from "@material-ui/core/Container"
import { useNavigate } from "react-router-dom"
import { urlPath } from "@/utils"

const useStyles = makeStyles((theme) => ({
    title: {
        color: "black",
        textAlign: "center",
        marginBottom: theme.spacing(5),
    },
    accOutContainer: {
        padding: theme.spacing(10, 4),
    },
    accInnerContainer: {
        display: "flex",
        listStyle: "none",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "flex-start",
    },
    accBlock: {
        flexBasis: "100%",
        padding: theme.spacing(3),
        [theme.breakpoints.up("md")]: {
            flexBasis: "50%",
        },
    },
    accInnerBlock: {
        boxShadow: "0 0 7px 3px rgb(0 0 0 / 6%)",
        borderRadius: "8px",
    },
    accBlockLink: {
        display: "flex",
        padding: theme.spacing(2),
        alignItems: "center",
        cursor: "pointer",
    },
    iconImage: {
        maxWidth: "130px",
    },
    iconWrapper: {
        padding: theme.spacing(2),
    },
    linkWrapper: {
        color: "black",
        padding: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        gap: "4px",
    },
    contentText: {
        color: "black",
        marginBottom: theme.spacing(1),
    },
    contentSubText: {
        fontSize: "16px",
        lineHeight: "24px",
        color: "#595959",
    },
}))

const AdminDashboard = (props) => {
    const { user } = props
    const { userId } = user
    const classes = useStyles()
    const navigate = useNavigate()

    const linkContent = useMemo(
        () => [
            {
                iconPath: "assets/accountHolder/account-icon-project-dashboard",
                text: "Report Ready",
                subText: "Set report link and email the client",
                newTab: false,
                path: urlPath("super-admin-report-ready"),
            },
        ],
        [userId]
    )

    const updateLandingPageContent = (path) => {
        navigate(path)
    }
    const childrenElement = (contentItem, loadProjectPanel = false, path = null) => {
        return (
            <Box className={classes.accInnerBlock}>
                <Box className={classes.accBlockLink} onClick={() => (loadProjectPanel ? updateLandingPageContent(path) : null)}>
                    <Box className={classes.iconWrapper}>
                        <DynamicImage path={contentItem.iconPath} extension="png" className={classes.iconImage} alt="icon" height={80} />
                    </Box>
                    <Box className={classes.linkWrapper}>
                        <Typography variant="h6" component="h3" className={classes.contentText}>
                            {contentItem.text}
                        </Typography>
                        <Typography className={classes.contentSubText}>{contentItem.subText}</Typography>
                    </Box>
                </Box>
            </Box>
        )
    }
    return (
        <Container component="main" maxWidth="lg">
            <Box className={classes.accOutContainer}>
                <Typography variant="h5" component="h1" className={classes.title}>
                    {`Hello, ${user.firstName} ${user.lastName}`}
                </Typography>
                <Box className={classes.accInnerContainer}>
                    {linkContent.map((contentItem) => {
                        if (!contentItem.newTab) {
                            return (
                                <Box className={classes.accBlock} key={contentItem.text}>
                                    {childrenElement(contentItem, true, contentItem.path)}
                                </Box>
                            )
                        }
                        return (
                            <a
                                href={contentItem.link}
                                target="_blank"
                                rel="noreferrer"
                                style={{ textDecoration: "none" }}
                                className={classes.accBlock}
                                key={contentItem.text}
                            >
                                {childrenElement(contentItem)}
                            </a>
                        )
                    })}
                </Box>
            </Box>
        </Container>
    )
}

export default AdminDashboard
